<script>
export default {
    methods: {
        // Función para cambiar la acción del PDV
        changePDVActionTo(action) {
            this.$store.setProductActionSelected(action);
        }
    },
    computed: {
        // Tabs disponibles para el PDV
        getTabsPDV() {
            return [
                {
                    id: 1,
                    title: "Mi carta",
                    param: "productManagementPDV",
                    show: true,
                    canBeHide: true,
                },
                {
                    id: 2,
                    title: "Administración de Stock",
                    param: "stockManagementPDV",
                    show: this.$store.getIsStockEnabled, 
                    canBeHide: true,
                },
            ];
        },
        
        // Tab actualmente seleccionado en el PDV
        pdvTabSelected() {
            let tabSelected = this.$store.getProductActionSelected || 'productManagementPDV';
            return this.getTabsPDV.filter((x) => x.param === tabSelected)[0] || this.getTabsPDV[0];
        }
    }
}
</script>
